import React, { useEffect, useState } from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate'; 
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig'; 

const TransactionListDetails = () => {
  const [transactions, setTransactions] = useState([]);



  useEffect(() => {
    

    const fetchAccountDetails = async (accountId) => {
        try {
          const url = `${API_DOMAIN}${API_ROUTES.account}${accountId}/`;
          const token = localStorage.getItem('token');
          
          const response = await axios.get(url, { headers });
          return response.data.name;
        } catch (error) {
          console.error('Error fetching account details:', error);
        }
      };


    const fetchTransactions = async () => {
      try {
        const url = `${API_DOMAIN}${API_ROUTES.transaction}`;

        const token = localStorage.getItem('token');
        
        const response = await axios.get(url, { headers });    
        const transactionsWithAccountDetails = await Promise.all(response.data.map(async (transaction) => {
        const accountDetails = await fetchAccountDetails(transaction.account);
        return { ...transaction, account_name: accountDetails };
        }));
        setTransactions(transactionsWithAccountDetails);
      } catch (error) {
        console.error('Error fetching transactions:', error);
      }
    };

    fetchTransactions();
  }, []);

  const columns = [
    { label: 'Reference Number', value: 'reference_number' },
    { label: 'Date', value: 'date' },
    { label: 'Account', value: 'account_name' },
    { label: 'Amount', value: 'amount' },
    { label: 'Transaction Type', value: 'transaction_type' },
    // { label: 'Description', value: 'description' },
    // { label: 'Created By', value: 'created_by' },
  ];

  const handleViewDetails = (transactionId) => {
    //console.log('View Details', transactionId);
    const encodedId = btoa(transactionId);
    window.location.href = `/transaction/details/${encodedId}`;
  };

  const actionButtons = [
    { label: 'View Details', handler: handleViewDetails },
  ];

  return <ListTemplate columns={columns} data={transactions} actionButtons={actionButtons} />;
};

export default TransactionListDetails;